import React from 'react';
import styled from 'styled-components';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { azure, spacer16, spacer20, screenSmMin } from '@spotify-internal/encore-foundation';
import { Unsubscribe } from './Unsubscribe';
import { UnsubscribeSuccess } from './UnsubscribeSuccess';
import { UnsubscribeError } from './UnsubscribeError';
import { SpotifyForPodcastersLogo } from '../../vendor/SpotifyForPodcastersLogo';

export function EmailUnsubscribe() {
  let match = useRouteMatch();

  if (!match) return <Redirect to="/" />;

  return (
    <Switch>
      <Route path={`${match.path}/unsubscribe/success`} component={UnsubscribeSuccess} />
      <Route path={`${match.path}/unsubscribe/error`} component={UnsubscribeError} />
      <Route path={`${match.path}/unsubscribe`} component={Unsubscribe} />
      <Redirect to="/" />
    </Switch>
  );
}

export function EmailUnsubscribeHeader() {
  return (
    <Header>
      <Logo>
        <SpotifyForPodcastersLogo />
      </Logo>
    </Header>
  );
}

const Header = styled.div`
  background-color: ${azure};
  padding: ${spacer16};

  @media (min-width: ${screenSmMin}) {
    padding: ${spacer20} 0 220px 150px;
  }
`;

const Logo = styled.div`
  width: 280px;
  height: 40px;
`;

export const Content = styled.div`
  padding: ${spacer16};

  @media (min-width: ${screenSmMin}) {
    min-height: 480px;
    padding: 120px 150px 175px;
  }
`;
